import state from './state'
import mutations from './mutations'
import actions from './actions'

/**
 * @description
 * This module manages the state of the sales cart: the list of products
 * to be processed in a single transaction.
 */
const SessionModule = {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
}

export default SessionModule
